export const DELIVERY_DRAFT_TYPE = 'delivery_form';
export const DELIVERY_DRAFT_RESOURCE_TYPE = 'delivery_list_drafts';
export const DELIVERY_DRAFT_RESOURCE_ID = 0;

export type DeliveryDraftStep = 'orders' | 'internalOrders';

export interface DeliveryDraftFilters {
    deliveryDates: string[];
    clientId: string | null;
    deliveryRegionId: string | null;
}

export interface DeliveryDraftPayload {
    deliveryDate: string;
    selectedOrders: string[];
    selectedInternalOrders: string[];
    filters: DeliveryDraftFilters;
    currentStep: DeliveryDraftStep;
}
